import Button from 'antd/lib/button';
import Space from 'antd/lib/space';
import * as React from 'react';
import { RouteProps, useHistory } from 'react-router-dom';
import { AuthProviderType, ThirdPartyAuthError } from '../../types';
import ThirdPartySignInIcon from '../icons/ThirdPartySignInIcon';
import qs from 'query-string';
import Icon from '@ant-design/icons';
import routes from '../../routes';
import { displayTextForThirdPartyAuthError, hubSpotUserToken } from '../../helpers';
import * as AnalyticEvents from '../../utils/analytics';
import { globalMessage } from '../../utils/globalMessage';
import { SignupIntentType } from './SignupComponent';
import * as Cookie from 'cookie';
import { STAPE_ID_COOKIE_KEY } from '@/constants';

export enum ThirdPartyAuthButtonVariant {
    Login = 'login',
    Signup = 'signup',
}

interface ThirdPartySSOButtonsProps extends RouteProps {
    variant: ThirdPartyAuthButtonVariant;
    intent?: SignupIntentType;
}

const ThirdPartySSOButtons: React.FC<ThirdPartySSOButtonsProps> = (props: ThirdPartySSOButtonsProps) => {
    const history = useHistory();

    const cookies = Cookie.parse(document.cookie);

    const sessionId = AnalyticEvents.getAmplitudeSessionId();
    const deviceId = AnalyticEvents.getAmplitudeDeviceId();

    const authUrlForAuthType = (authType: AuthProviderType) => {
        const queryParams = {
            authProvider: authType,
            redirectPath: `${routes.dashboard}`,
            hubSpotUserToken: hubSpotUserToken(document),
            stapeId: cookies[STAPE_ID_COOKIE_KEY],
            sessionId,
            deviceId,
            signupIntent: props.intent,
        };

        const encodedParams = qs.stringify(queryParams);

        return `${window.location.origin}/api/thirdparty/authStart?${encodedParams}`;
    };

    const queryParams = qs.parse(props.location?.search);
    const authError = queryParams.authError;

    const GoogleAuthIcon = () => {
        return <ThirdPartySignInIcon authProvider={AuthProviderType.Google} />;
    };

    const GitHubAuthIcon = () => {
        return <ThirdPartySignInIcon authProvider={AuthProviderType.GitHub} />;
    };

    React.useEffect(() => {
        if (authError) {
            const displayErrorText = displayTextForThirdPartyAuthError(authError as ThirdPartyAuthError);

            globalMessage.error(displayErrorText);

            console.debug(
                '[REDIRECT DEBUG]',
                'authError',
                authError,
                'window.location.pathname',
                window.location.pathname,
            );
            // clear authError query param & prevent back navigation
            history.replace(window.location.pathname);
        }
    }, [authError]);

    const buttonStyle: React.CSSProperties = {
        width: '100%',
    };

    const buttonPrefixText = props.variant === ThirdPartyAuthButtonVariant.Login ? 'Sign in' : 'Sign up';

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <Button
                href={authUrlForAuthType(AuthProviderType.Google)}
                icon={<Icon component={GoogleAuthIcon} />}
                style={buttonStyle}
            >
                {buttonPrefixText} with Google
            </Button>
            <Button
                href={authUrlForAuthType(AuthProviderType.GitHub)}
                icon={<Icon component={GitHubAuthIcon} />}
                style={buttonStyle}
            >
                {buttonPrefixText} with GitHub
            </Button>
        </Space>
    );
};

export default ThirdPartySSOButtons;
